import { EnvConfig } from '../types';

const developmentConfig: EnvConfig = {
  // GTM
  GTM_ENABLED: false,

  // API
  API_URL: 'http://localhost:9000',

  DISABLED_FEATURES: {},
};

export default developmentConfig;
